import React, { FunctionComponent, lazy } from 'react';
import { withTopNav } from 'components/Navigation';
import { Switch, Route, useRouteMatch } from 'react-router-dom';
import { AnalyticsPage } from '@inplayer-org/inplayer-ui';

const Webhooks = lazy(() => import('pages/MerchantPages/Api/containers/Webhooks'));
const WebhooksDetails = lazy(() => import('pages/MerchantPages/Api/containers/WebhooksDetails'));
const AddWebhook = lazy(() => import('pages/MerchantPages/Api/containers/AddWebhook'));

const Api: FunctionComponent<{}> = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}`}>
        <AnalyticsPage tag="webhooks" type="page">
          <Webhooks />
        </AnalyticsPage>
      </Route>
      <Route path={`${path}/edit/:id`} component={WebhooksDetails} />
      <Route path={`${path}/add`} component={AddWebhook} />
    </Switch>
  );
};

export default withTopNav(Api);
